import Logo from "componentsTemplate/Logo/Logo";
import React, { FC } from "react";

export interface HeaderProps {}

const HeaderEmpty: FC<HeaderProps> = () => {
  return (
    <div className="nc-Header sticky top-0 w-full z-40">
      <div className="nc-MainNav2 relative z-10 bg-white dark:bg-slate-900 ">
        <div className="container">
          <div className="h-20 flex justify-between">
            <div className="flex items-center md:hidden flex-1">
            </div>

            <div className="flex lg:flex-1 items-center space-x-3 sm:space-x-8">
              <Logo />
              <div className="hidden md:block h-10 border-l border-slate-200 dark:border-slate-700"></div>

              <div className="hidden sm:block flex-grow max-w-xs">
              </div>
            </div>

            <div className="flex-1 flex items-center justify-end ">
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderEmpty;
